// const cache = new Map();
// const inflight = new Map();

// const makeKey = (keyObj) => JSON.stringify(keyObj);

// export const getCachedPage = (keyObj) => {
//   return cache.get(makeKey(keyObj));
// };

// export const setCachedPage = (keyObj, value) => {
//   cache.set(makeKey(keyObj), value);
// };

// export const getInflight = (keyObj) => {
//   return inflight.get(makeKey(keyObj));
// };

// export const setInflight = (keyObj, promise) => {
//   inflight.set(makeKey(keyObj), promise);
// };

// export const clearInflight = (keyObj) => {
//   inflight.delete(makeKey(keyObj));
// };


// utils/paginatedSelectCache.js
const cache = new Map();
const inflight = new Map();

const makeKey = (keyObj) => JSON.stringify(keyObj);

export const getCachedPage = (keyObj) => {
  return cache.get(makeKey(keyObj));
};

export const setCachedPage = (keyObj, value) => {
  const key = makeKey(keyObj);
  cache.set(key, {
    ...value,
    _metadata: {
      name: keyObj.name,
      limit: keyObj.limit,
      search: keyObj.search || "",
      page: keyObj.page
    }
  });
};

export const getInflight = (keyObj) => {
  return inflight.get(makeKey(keyObj));
};

export const setInflight = (keyObj, promise) => {
  inflight.set(makeKey(keyObj), promise);
};

export const clearInflight = (keyObj) => {
  inflight.delete(makeKey(keyObj));
};

// Function to get all cached pages for a specific search
export const getAllCachedPages = (name, limit, search = "") => {
  const allPages = [];
  
  for (const [key, value] of cache.entries()) {
    if (value._metadata && 
        value._metadata.name === name &&
        value._metadata.limit === limit &&
        value._metadata.search === search) {
      allPages.push({
        page: value._metadata.page,
        options: value.options,
        totalPages: value.totalPages
      });
    }
  }
  
  return allPages;
};